import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { retryableErrors, type TargetResult } from '../domain/session-detail.model';
import {
  buildPipelineSteps,
  type LedgerTotals,
  ledgerTotals,
  type PipelineStepView,
} from '../domain/session-pipeline.model';

const selectSessionDetail = (state: RootState) => state.sessionDetail;

export const selectSession = (state: RootState) => selectSessionDetail(state).session;
export const selectLoadStatus = (state: RootState) => selectSessionDetail(state).loadStatus;
export const selectMutation = (state: RootState) => selectSessionDetail(state).mutation;

/** Failed targets worth retrying (memoised; drives the "Retry N errors" button). */
export const selectRetryableErrors = createSelector(
  selectSession,
  (session): TargetResult[] => (session ? retryableErrors(session.profile_results) : []),
);

/** One card per pipeline step, ledger-derived (memoised; drives the Pipeline section). */
export const selectPipelineSteps = createSelector(
  selectSession,
  (session): PipelineStepView[] => (session ? buildPipelineSteps(session) : []),
);

/** Session totals counted in step results (memoised; drives the summary band). */
export const selectLedgerTotals = createSelector(
  selectSession,
  (session): LedgerTotals | null => (session ? ledgerTotals(session) : null),
);
